// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CallSummaryForm_wrapper__19Ags","interventions":"CallSummaryForm_interventions__2nx4i"};